// layout swicth
$(document).on("click", ".layout_wrap .layout", function () {
  $(this).addClass("active_layout").siblings().removeClass("active_layout");
});

$(document).on("click", ".search_tabs_col", function () {
  $(this).addClass("act_tab").siblings().removeClass("act_tab");
});
$(document).on('click','.btn_tumbler',function(){
    $('.tab_tumbler').show()
    $('.tab_clearance').hide()
    $('.tab_deals').hide()
})
$(document).on('click','.btn_clearance',function(){
    $('.tab_tumbler').hide()
    $('.tab_clearance').show()
    $('.tab_deals').hide()
})
$(document).on('click','.btn_deals',function(){
    $('.tab_tumbler').hide()
    $('.tab_clearance').hide()
    $('.tab_deals').show()
})
// $(document).on("change", ".my_variants", function () {
//   var vl = $(this).find(':selected').attr('data-id');
//   $(this).parent().parent().find('.upsell-check-lid').attr('data-id',vl)
// });
$(document).on("click", ".upsell-check-lid", function () {
  $(this).parent().parent().find(".variant_selection").toggle();
});
$(document).on("click", "button.cust_dropbtn", function () {
  $(".dropdown-content.show").removeClass("show");
  $(this).next().addClass("show");
  $(this).addClass("act");
});
$(document).on("click", "button.act", function () {
  $(this).next().removeClass("show");
  $(this).removeClass("act");
});
$(document).on("click", ".collection_list_view", function () {
  $(".grid.grid--uniform").attr("data-view", "collection_list");
});
$(document).on("click", ".collection_grid_view", function () {
  $(".grid.grid--uniform").attr("data-view", "collection_grid");
});
$(document).on("click", ".sort_select", function () {
  $(".select_val").toggle(100);
  $(this).toggleClass("act");
});
$(document).on(
  "click",
  ".hide_style_and_size .variant-input .variant__button-label",
  function () {
    var vl = $(this).html();
    $(this).parent().parent().prev().find(".variant__label-info span").html(vl);
  }
);
$(document).on("click", ".show_more_variant", function () {
  $(this).toggleClass("open_var");
  $(".color-variant-input-wrap").toggleClass("h_auto");
  $(this).html("—");
});
$(document).on("click", ".open_var", function () {
  $(this).html("+");
});
$(document).ready(function () {
  $(".hide_parent").parent().parent().hide();
  setTimeout(function () {
    $(".custom_counter").css("opacity", "1");
  }, 600);
});
$(document).on("keyup", "#myInput", function () {
  var value = $(this).val().toLowerCase();
  $(this)
    .next()
    .find("li span")
    .filter(function () {
      $(this)
        .parent()
        .parent()
        .toggle($(this).text().toLowerCase().indexOf(value) > -1);
    });
});
// variant change
document.addEventListener("variant:change", function (evt) {
  setTimeout(function () {
    const val = $(".product__price").html().replace("$", "");
    const divided_by = 4;
    const num = val / divided_by;
    $("#afterpay_update").html(num.toFixed(2));
  }, 300);
});

// if ($(window).width() < 650) {
//   setTimeout(function () {
//     var vl = $(".header_padding").height();
//     var stickyOffsets = $(".custom_pd_atc").offset().top;

//     $(document).on("scroll", function () {
//       var main = stickyOffsets - vl;
//       var stickys = $(".custom_pd_atc"),
//         scrolls = $(window).scrollTop();
//       if (scrolls >= main) stickys.addClass("stick_bot").css("top", vl);
//       else stickys.removeClass("stick_bot");
//     });
//   }, 700);
// }

setInterval(function () {
  $.getJSON("/cart.js", function (cart) {
    var vl = cart.item_count;
    $(".cart-link__bubble").html(vl);
  });
}, 1000);

setInterval(function () {
  var ss = $(".loox-rating span");
  for (var i = 0; i < ss.length; i++) {
    var sss = $(ss[i]).html();
    sss = sss.replace("(", "");
    sss = sss.replace(")", " Reviews");
    $(ss[i]).html(sss);
  }
  setTimeout(function () {
    $(".loox-rating").css("opacity", "1");
  }, 500);
});
$(document).on("keyup", ".site-header__search-input", function () {
  var vl = $(".site-header__search-input").val();
  if (vl == "") {
    $(".custom_search_wrapper").show();
    $(".seacrh_btn").hide();
  } else {
    $(".custom_search_wrapper").hide();
    $(".seacrh_btn").show();
  }
});

setInterval(function () {
  $(".site-header__search-form .site-header__search-input").focus();
}, 500);

if ($(window).width() < 767) {
  setInterval(function () {
    $(".product__photos .flickity-page-dots .dot").hide();
    $(".product__photos .flickity-page-dots .is-selected").show();
    $(".product__photos .flickity-page-dots .is-selected").next().show();
    $(".product__photos .flickity-page-dots .is-selected").next().next().show();
    $(".product__photos .flickity-page-dots .is-selected")
      .next()
      .next()
      .next()
      .show();
    $(".product__photos .flickity-page-dots .is-selected").prev().show();
    $(".product__photos .flickity-page-dots .is-selected").prev().prev().show();
    $(".product__photos .flickity-page-dots .is-selected")
      .prev()
      .prev()
      .prev()
      .show();
  });
}
// after pay logo inline

// cart remove
function remove(a) {
  var vid = $(a).attr("data-id");
  vid = parseInt(vid);

  $.ajax({
    async: false,
    type: "POST",
    url: "/cart/change.js",
    data: {
      quantity: 0,
      id: vid,
    },
    dataType: "json",
    success: function () {
      document.dispatchEvent(new CustomEvent("cart:build"));
    },
  });
}
// upsell
$(document).on("click", "button.add-to-cart", function () {
  if (
    $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .find(".upsell-check-1")
      .is(":checked")
  ) {
    var vid = $(".upsell-check-1").attr("data-id");
    vid = parseInt(vid);

    $.ajax({
      async: false,
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: vid,
      },
      dataType: "json",
      success: function () {
        document.dispatchEvent(new CustomEvent("cart:build"));
      },
    });
  }
  if (
    $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .find(".upsell-check-2")
      .is(":checked")
  ) {
    var vid = $(".upsell-check-2").attr("data-id");
    vid = parseInt(vid);

    $.ajax({
      async: false,
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: vid,
      },
      dataType: "json",
      success: function () {
        document.dispatchEvent(new CustomEvent("cart:build"));
      },
    });
  }
});

// thumbnails click variant selection
$(document).on("click", ".product__thumb-item .product__thumb", function () {
  if (!$(".show_more_variant").hasClass("open_var")) {
    $(".show_more_variant").trigger("click");
  }
  var variantImageChange = $(this).attr("data-image");
  var v2 = $('.mynav span[data="' + variantImageChange + '"]');
  var v3 = $(v2).attr("data-image");
  var vl = $('.my_var .var_tiles[data-image="' + v3 + '"]');
  var a1 = $(vl).find("span:nth-child(1)").html();
  var a2 = $(vl).find("span:nth-child(2)").html();
  var a3 = $(vl).find("span:nth-child(3)").html();

  $('.trigger_1 .variant-input label[data-image="' + a1 + '"]').trigger(
    "click"
  );
  $('.trigger_2 .variant-input label[data-image="' + a2 + '"]').trigger(
    "click"
  );
  $('.trigger_3 .variant-input label[data-image="' + a3 + '"]').trigger(
    "click"
  );
});
$(document).on('click','.product__main-photos .flickity-button',function(){
    setTimeout(function(){
        $('.product__thumb.is-active').trigger('click')
    },300)
})
$(window).on("load", function () {
  if ($(".product-personalizer button").length > 0) {
    $(".product-personalizer button").click();
  }
});
$(document).on('click','.button-dark',function(){
  
  var a1 = $(this).parent().parent().find('.var_1 option:selected').attr('data-id')
  var a2 = $(this).parent().parent().find('.var_2 option:selected').attr('data-id')
  var a3 = $(this).parent().parent().find('.var_3 option:selected').attr('data-id')
  var all = a1+a2+a3
  var id  = $(this).parent().parent().find('.all_var span[data-name="' + all + '"]').html()
  var selling_plan  = $(this).parent().parent().find('.all_var span[data-name="' + all + '-plan"]').html()

  $.ajax({
      async: false,
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: id,
        selling_plan
      },
      dataType: "json",
      success: function () {
        document.dispatchEvent(new CustomEvent("cart:build"));
        setTimeout(function(){
          $('.js-drawer-open-cart .cart-link').trigger('click');
        },500)
      },
    });
    
})

  document.addEventListener('DOMContentLoaded', function () {
   const trigger = document.querySelector('.upsell-product'); // adjust selector
    const buyButton = document.querySelector('.buy_button_cover');
 function checkSticky() {
      const triggerBottom = trigger.getBoundingClientRect().bottom;

      if (triggerBottom <= 0) {
        buyButton.classList.add('sticky');
      } else {
        buyButton.classList.remove('sticky');
      }
    }

    // Initial check and scroll listener
    checkSticky();
    window.addEventListener('scroll', checkSticky);
});


document.addEventListener("DOMContentLoaded", function() {
  // Run only on the Christmas 2025 collection page
  if (window.location.pathname.includes("/2025-christmas-collection")) {
    const snowContainer = document.createElement('div');
    snowContainer.classList.add('snow-container');
    document.body.appendChild(snowContainer);

    // Create multiple snowflakes
    for (let i = 0; i < 40; i++) {
      const snowflake = document.createElement('div');
      snowflake.classList.add('snowflake');
      snowflake.style.left = Math.random() * 100 + 'vw';
      snowflake.style.animationDuration = 5 + Math.random() * 5 + 's';
      snowflake.style.opacity = Math.random();
      snowflake.style.fontSize = 12 + Math.random() * 14 + 'px';
      snowflake.textContent = '❄';
      snowContainer.appendChild(snowflake);
    }
  }
});

